<script setup lang="ts">
import type { PayCallbackType } from '@composables/usePay'

definePageMeta({
  layout: 'call-back',
})

useSetSEO()

const route = useRoute()
const { sender } = usePostMessage()

onBeforeMount(() => {
  // 결제 모듈 창으로 부터 받은 정보 전달
  // 결제 모듈쪽에서 /callback/pay 를 리다이렉트 했다는 의미는 결제가 완료 되었는지 결제 중인지 아직 알 수 없지만 결제 모듈이 닫혀 백엔드 쪽에 API를 호출하여 결제 상태를 확인해야함
  const payload: PayCallbackType = {
    merchantOrderNo: String(route.query.merchantOrderNo),
    creatorUserSn: Number(route.query.creatorUserSn),
    autoFollow: JSON.parse(String(route.query.autoFollow)),
  }

  sender('opener', { res: payload, type: 'pay' }, true)
})
</script>

<template>
  <NovaLoadingIndicator :bg-bright="'light'" :fill="true" />
</template>
